module.exports = __webpack_public_path__ + "static/media/LEDWall.69a824e1.jpg";